export default {
  async carregarRodape(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    if (!enderecoLoja) {
      console.error("Token not available");
      return;
    }

    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Empresa/Get?token=${enderecoLoja}`
    );

    const responseData = await response.json();

    const empresa = {
      logradouro: responseData[0].logradouro,
      nome: responseData[0].nome_fantasia,
      numero: responseData[0].numero,
      cnpj: responseData[0].cnpj,
      bairro: responseData[0].bairro,
      cidade: responseData[0].nome_municipio,
      cep: responseData[0].cep,
      telefone: responseData[0].telefone,
      email: responseData[0].email,
      url_logo: responseData[0].url_logo,
      whatsappcontato: responseData[0].whatsappcontato,
      facebook: responseData[0].catalogo_facebook,
      instagram: responseData[0].catalogo_instagram,
      tiktok: responseData[0].catalogo_tiktok,
      youtube: responseData[0].catalogo_youtube,
      menu_categorias: responseData[0].catalogo_menu_categorias,
    };

    document.documentElement.style.setProperty(
      "--primary-color",
      responseData[0].corcatalogo
    );

    context.commit("carregarRodape", empresa);
  },

  async carregarBanners(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    if (!enderecoLoja) {
      console.error("Token not available");
      return;
    }

    try {
      const response = await fetch(
        `https://apiciriuserp.com.br:2083/api/Banner/Get?token=${enderecoLoja}`
      );

      const responseData = await response.json();

      const bannersAtivos = responseData
        .filter((banner) => banner.ativo === true)
        .sort((a, b) => a.sequencia - b.sequencia);

      context.commit("setBanners", bannersAtivos);
    } catch (error) {
      console.error("Erro ao carregar banners:", error);
      context.commit("setBanners", []);
    }
  },

  async carregarVendedores(context, payload) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];
    const cnpj = payload.codigoempresa;
    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Vendedor/Get/0?token=${enderecoLoja}&cnpj=${cnpj}`
    );

    const responseData = await response.json();
    const vendedores = [];

    for (const key in responseData) {
      const vendedor = {
        nome: responseData[key].nome,
        codigo_vendedor: responseData[key].codigo_vendedor,
      };
      vendedores.push(vendedor);
    }
    context.commit("setarVendedores", vendedores);
  },

  async carregarFiliais(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    if (!enderecoLoja) {
      console.error("Token not available");
      return;
    }

    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Empresa/Get?token=${enderecoLoja}`
    );

    const responseData = await response.json();

    // responseData is expected to be an array of company objects
    // Map to keep full objects (razao and cnpj etc.) for the select
    const filiais = responseData.map((item) => ({
      razao: item.razao || item.nome_fantasia || "",
      cnpj: item.cnpj,
      nome_fantasia: item.nome_fantasia,
      url_logo: item.url_logo || item.url_logo,
      corcatalogo: item.corcatalogo || "#31b19a",
    }));

    context.commit("setarFiliais", filiais);
  },

  //mostrar endereco de entrega ou nao
  async carregarGlobal(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Global/Get?pParametro=99101&token=${enderecoLoja}`
    );

    const responseData = await response.json();

    context.commit("setarGlobal", responseData);
  },

  async permissaoUsuario(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Global/Get?pParametro=99345&token=${enderecoLoja}`
    );

    const responseData = await response.json();

    context.commit("setarPermissaoUsuario", responseData);
  },

  async mostrarEstoque(context) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Global/Get?pParametro=99347&token=${enderecoLoja}`
    );

    const responseData = await response.json();

    context.commit("setarMostrarEstoque", responseData);
  },
};
